import { AnimationItemState } from '../../models/animation-item-state-model';

export const createAnimationProcessItems = (): { [key: string]: AnimationItemState } => ({
  card1: new AnimationItemState({
    name: 'card1',
    title: 'Pronto podrás comenzar a usarla',
    description: 'Espera un momento, estamos validando tu información'
  }),
  card2: new AnimationItemState({
    name: 'card2',
    title: 'Pronto podrás comenzar a usarla',
    description: 'Estamos agregando tu tarjeta de forma segura'
  }),
  card3: new AnimationItemState({
    name: 'card3',
    title: 'Tu tarjeta está lista para realizar pagos',
    description: 'Añadida con éxito'
  })
});
